import init from '../../../js/init';

const name = 'notificationBar';
const selector = '.notifications';
const dismissBtnSelector = `${selector}__dismiss`;
const notificationListSelector = `${selector}__list`;
const fadeClass = `${selector}--fade`.substring(1);
const hiddenClass = `hidden`;
const animationDuration = 200;

init(Drupal, name, selector, root => {
  const dismissBtn = root.querySelector(dismissBtnSelector);
  const listItem = root.querySelector(notificationListSelector);
  const api = listItem.dataset.api;
  const cookie_prefix = 'dismiss_notification_';

  dismissBtn.onclick = () => {
    root.style.height = `${root.offsetHeight}px`;
    root.classList.add(fadeClass);
    setCookie(listItem.dataset.notificationId, '1');

    setTimeout(() => {
      root.classList.add(hiddenClass);
      root.style.height = '';

      setTimeout(() => {
        root.parentNode.removeChild(root);
      }, animationDuration);
    }, animationDuration);
  };

  const loadData = () => {
    fetch(api).then(function (result) {
      result.json().then(function (data) {
        handleModal(data.content, data.id);
      });
    });
  }

  const handleModal = (content, id) => {
    const cookieExists = getCookie(id);
    if (cookieExists === null && id !== '') {
      root.classList.remove(hiddenClass);
      listItem.innerHTML = content;
      listItem.dataset.notificationId = id;
      if (Drupal !== undefined && Drupal.behaviors !== undefined) {
        if (Drupal.behaviors.ckeditorReadmore !== undefined) {
          Drupal.behaviors.ckeditorReadmore.attach(listItem.innerHTML, {});
        }
        if (Drupal.behaviors.readmoreHelper !== undefined) {
          Drupal.behaviors.readmoreHelper.attach(listItem.innerHTML, {});
        }
      }
    }
  }

  const setCookie = (id) => {
    document.cookie = cookie_prefix + id + "=1; path=/";
  }

  const getCookie = (id) => {
    const nameEQ = cookie_prefix + id + "=";
    const ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  loadData();
});
